export function isEqualFulfillmentOption(x, y) {
    if (x.type !== y.type ||
        x.profileId !== y.profileId ||
        x.location.geohash !== y.location.geohash ||
        x.price !== y.price)
        return false;
    if (x.type === "physical" && y.type === "physical") {
        return x.date === y.date && x.modality === y.modality;
    }
    else {
        return (x.type === y.type &&
            x.profileId === y.profileId &&
            x.location.geohash === y.location.geohash &&
            x.price === y.price);
    }
}
//# sourceMappingURL=fulfillment-options.js.map